var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentUserInfo.userId === _vm.hostId)?_c('button',{staticClass:"btn",on:{"click":_vm.deleteEvent}},[_c('p',[_vm._v(" delete event ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }